import { VHCRecordLabourInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateWheelLabourInput = {
  logId: number;
  itemId: number;
  labourId: number;
  requestBody?: VHCRecordLabourInput;
};

export const useUpdateWheelLabourMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsWheelTyresLabours, UpdateWheelLabourInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, labourId, requestBody }: UpdateWheelLabourInput) =>
      VhcRecordLogService.putVhcRecordsItemsWheelTyresLabours(logId, itemId, labourId, requestBody),
    options
  );
